/* unplugin-vue-components disabled */import { render } from "./Privacy.vue?vue&type=template&id=f656ef84&scoped=true"
const script = {}

import "./Privacy.vue?vue&type=style&index=0&id=f656ef84&scoped=true&lang=css"

import exportComponent from "/Users/hongboyuan/projects/yszn-code/qipaoWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f656ef84"]])

export default __exports__